<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
import axios from "axios";
import moment from "moment";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Active Visits",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
        advancedsearch: {
        search: "",
        date1: "",
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      filterdArray: [],
      edit: false,
      test: "",
      modal_id: "",
      title: "Active Visits",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Clients",
          href: "#/",
        },
        {
          text: "Active Visits",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      filterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "patient.patientCode",
          sortable: true,
          label: "CODE",
        },
        {
          key: "patientName",
          sortable: true,
          label: "PATIENT",
        },
        {
          key: "patient.patientContact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "gender",
          sortable: true,
          label: "GENDER",
        },
        {
          key: "ages",
          sortable: true,
          label: "AGE",
        },
        {
          key: "services",
          sortable: true,
          label: "SERVICES",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // PATIENT SERVICES
      patient_services: {
        name: "",
        visit_id: "",
        services: [],
        completetests: [],
        labrequests: [],
      },
      editdata: {
        new_name: "",
        id: "",
        age: "",
        age_unit: "",
        temperature: "",
        mauc: "",
        nextofkin: "",
        nextofkincontact: "",
        weight: "",
        height: "",
        pulse: "",
        pressure: "",
        visitdate: "",
      },
      deletedata: {
        visit_id: "",
        service_id: "",
        type: "",
        reason: "",
      },
      visit_age: "",
      visit_ageunit: "",
      addservicex: {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: "",
        patient_service: "",
        quantity: "1",
        service: "",
        service_cost: "",
        minimum_price: 0,
        visit_id: "",
      },
      add_drug: {
        active:true,
        drug_id: "",
        quantity: "1",
        price: "",
        rec_dosage: "",
        visit_id: "",
        notDoctor: true,
        insurance_company: "",
        package_id: "",
        insurance_status: "0",
      },
      reasonError: "",
      InsError: "",
      pack: "",
      deptError: "",
      serviceError: "",
      qtyError: "",
      priceError: "",
      itemError: "",
      doseError: "",
      search_status:false,
      managePrescription: {},
      // CLOSE VISIT
      close_visit: {
        balance: "",
        patient_name: "",
        visit_id: "",
      },
      // END CLOSE VISIT
    };
  },
  computed: {
       totalRecords: function () {
      return this.filterdArray ? this.filterdArray.length : 1
    },
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("patients", ["active_patients", "saving_status"]),
    ...mapGetters("pharmacy", ["PharmacyItems", "DrugAgeRange"]),
    ...mapGetters("visits", ["OrderServiceStatus"]),
    ...mapGetters("insurance", ["PaymentType", "InsurancePackageServices"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("services", [
      "department_add",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
      "InpatientServices",
      "antenatalServices"
    ]),

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevices: function () {
      if (this.addservicex.department == 1) {
        return this.consultationServices;
      } else if (this.addservicex.department == 2) {
        return this.radiologyServices;
      } else if (this.addservicex.department == 3) {
        return this.procedureServices;
      } else if (this.addservicex.department == 4) {
        return this.labServices;
      } else if (this.addservicex.department == 6) {
        return this.dentalServices;
      } else if (this.addservicex.department == 7) {
        return this.antenatalServices;
      } else if (this.addservicex.department == 8) {
        return this.InpatientServices;
      } else {
        return [];
      }
    },

    //  SERVICES FOR INSURANCE PACKAGE
    filterSevicesx: function () {
      return this.InsurancePackageServices.filter((serv) => {
        return (
          serv.serviceType == this.addservicex.department &&
          serv.package_id == this.pack
        );
      });
    },
        filterDrugx: function () {
      return this.InsurancePackageServices.filter((serv) => {
        if(this.pack){
      return (serv.serviceType == 5 && serv.package_id == this.pack);
        }else{
          return []
        }
        
      });
    },
  
    // GET SERVICE PRICE
    SevicesPrice: function () {
      if (this.addservicex.department == 1) {
        return this.consultationServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else if (this.addservicex.department == 2) {
        return this.radiologyServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else if (this.addservicex.department == 3) {
        return this.procedureServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else if (this.addservicex.department == 4) {
        return this.labServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else if (this.addservicex.department == 6) {
        return this.dentalServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else if (this.addservicex.department == 7) {
        return this.antenatalServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else if (this.addservicex.department == 8) {
        return this.InpatientServices.filter((ser) => {
          return ser.id == this.addservicex.service;
        });
      } else {
        return "0";
      }
    },
    /**
     * Total no. of records
     */

    rows() {
      return this.active_patients ? this.active_patients.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.active_patients ? this.active_patients.length : 1;
  },

  watch: {
    active_patients(newVal) {
      if (newVal) {
        this.AssignPatient();
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeModal(this.modal_id);
          this.closeModal("modal-lg");
             this.closeModal("modal-close_visit");
          this.resetAdd();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    // active_patients(newValue) {
    //   // Do whatever makes sense now
    //   if (newValue) {
    //     this.FetchActivePatients();
    //   }
    // },
  },
  methods: {
    ...mapActions({
      FetchActivePatients: "patients/fetchActivePatients",
      FetchPatients: "patients/fetchPatients",
      EditVisit: "patients/editVisit",
      RemoveServe: "patients/removeService",
      AddService: "visits/AddService",
      FetchConsultationPatients: "doctor/fetchConsultationPatients",
      FetchAntenatalPatients: "doctor/fetchAntenatalPatients",
      FetchDentalPatients: "doctor/fetchDentalPatients",
      FetchRadiologyPatients: "doctor/fetchRadiologyPatients",
      FetchProcedurePatients: "doctor/fetchProcedurePatients",
      FetchPatientPayments: "payments/fetchPatientPayments",
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      FetchAntentalServices: "services/fetchAntenatalServices",
      FetchInsuranceServices: "insurance/fetchInsPackageServices",
      FetchInpatient: "services/fetchInpatientServices",
      AddDrug: "visits/AddDrug",
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      CloseVisit: "visits/closeVisit",
      FetchDosage: "pharmacy/fetchDrugageRange",
    }),

    AssignPatient() {
      this.filterdArray = this.active_patients;
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // END COMMA SEPERATOR
    SearchPatient() {
      this.search_status = true;
      axios
        .post("search_active_patient", this.advancedsearch)
        .then((response) => {
          this.search_status = false;
          this.filterdArray = response.data.data;
        })
        .catch(() => {
          this.search_status = false;
        });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // MANAGE PRESCRIPTIONS
    setPrescriptions(data) {
      let manage = {
        patient_name: data.patient.patientName,
        prescriptions: data.prescriptions,
      };
      this.managePrescription = manage;
    },
    // END MANAGE PRESCRIPTIONS
    checkStaus() {
      if (this.addservicex.insurance_status == "1" && this.pack == "") {
        this.InsError =
          "This patient can only take services on a personal bill";
      } else {
        this.InsError = "";
      }
    },
    // VIEW  SERVICES METHOD
    //CHECK INSURANCE STATUS ON ADDING DRUG
    checkInsuranceStaus() {
      if (this.add_drug.insurance_status == "1" && this.pack == "") {
        this.InsError = "This patient can only take drugs on a personal bill";
      } else {
        this.InsError = "";
      }
    },
    //END CHECK INSURANCE STATUS ON ADDING DRUG
    View_Services(data) {
    
      this.visit_age = data.item.age;
      this.visit_ageunit = data.item.age_unit;

      if (data.item.is_insured == "insurance") {
        this.test = data.item;
        this.pack =  data.item.insurepackage.id;
        this.addservicex.insurance_status = "1";
        this.addservicex.insurance_company = data.item.inscompany.company_id;
        this.add_drug.insurance_status = "1";
        this.add_drug.package_id = data.item.insurepackage.id;
        this.add_drug.insurance_company = data.item.inscompany.company_id;
        this.FetchInsuranceServices(data.item.insurepackage.id);
      } else {
        this.pack = "";
        this.addservicex.insurance_status = "0";
        this.addservicex.insurance_company = "";
        this.add_drug.insurance_status = "0";
        this.add_drug.package_id = "";
        this.add_drug.insurance_company = "";
      }
      (this.patient_services.services = data.item.patientservices),
        (this.patient_services.completetests = data.item.completetests),
        (this.patient_services.labrequests = data.item.labrequests),
        (this.patient_services.name = data.item.patient.patientName);
      this.patient_services.visit_id = data.item.id;
      this.addservicex.visit_id = data.item.id;
      this.addservicex.patientId = data.item.patient.id;
      this.add_drug.visit_id = data.item.id;
      this.add_drug.patientId = data.item.patient.id;
      
    },
    resetAdd() {
      this.addservicex.department = "";
      this.addservicex.insurance_company = "";
      this.addservicex.insurance_status = "0";
      this.addservicex.patientId = "";
      this.addservicex.patient_service = "";
      this.addservicex.quantity = "1";
      this.addservicex.service = "";
      this.addservicex.service_cost = "";
      this.addservicex.visit_id = "";
    },
    showEditModal(data) {
      this.modal_id = "edit-visit-modal";
      this.editdata.new_name = data.item.patient.patientName;
      this.editdata.pressure = data.item.pressure;
      this.editdata.temperature = data.item.temp;
      this.editdata.mauc = data.item.muac;
      this.editdata.age = data.item.age;
      this.editdata.id = data.item.id;
      this.editdata.age_unit = data.item.age_unit;
      this.editdata.weight = data.item.weight;
      this.editdata.height = data.item.height;
      this.editdata.nextofkin = data.item.nextOfKin;
      this.editdata.visitdate = data.item.editvisitDate;
      this.editdata.nextofkincontact = data.item.nextOfKinPhone;
    },
    showDeleteModal(id, type) {
      this.deletedata.service_id = id;
      this.deletedata.type = type;
      this.deletedata.visit_id = this.patient_services.visit_id;
    },
    RemoveService(modalId) {
      if (this.deletedata.reason == "") {
        this.reasonError = "Please enter a reason for removing this service";
        return;
      } else if (this.deletedata.reason.length < 15) {
        this.reasonError = "Please enter a clear and descriptive reason.";
        return;
      } else if (!/\s/.test(this.deletedata.reason)) {
        this.reasonError = "Please enter a valid reason.";
        return;
      } else {
        this.reasonError = "";
      }
      this.modal_id = modalId;
      this.RemoveServe(this.deletedata);
    },
    // SET SERVICE PRICE
    getPrice() {
      this.addservicex.service_cost = this.SevicesPrice[0].servicePrice.replace(/,/g, '');
      this.addservicex.minimum_price = this.addservicex.service_cost;
    },

    getCost() {
      if (this.addservicex.department != "") {
        let this_serv = this.InsurancePackageServices.filter((ser) => {
          return (
            ser.serviceId == this.addservicex.service &&
            ser.package_id == this.pack
          );
        });
        this.addservicex.service_cost = this_serv[0].servicePrice;
        // alert('We got: '+this_serv[0]);
        // eslint-disable-next-line no-console
        //console.log(this_serv[0].servicePrice);
        this.addservicex.minimum_price = this.addservicex.service_cost;

        
      } else {
        return "0";
      }
    },

    addService(modelId) {
      this.modal_id = modelId;
      if (this.addservicex.insurance_status == "1" && this.pack == "") {
        this.InsError =
          "This patient can only take services on a personal bill";
        return;
      } else {
        this.InsError = "";
      }
      if (this.addservicex.department == "") {
        this.deptError = "Service Category field is required";
        return;
      } else {
        this.deptError = "";
      }

      if (this.addservicex.insurance_status == "") {
        this.InsError = "Payment Type field is required";
        return;
      } else {
        this.InsError = "";
      }

      if (this.addservicex.service == "") {
        this.serviceError = "Service field is required";
        return;
      } else {
        this.serviceError = "";
      }

      if (this.addservicex.quantity == "" || this.add_drug.quantity < 0.1) {
        this.qtyError = "Quantity field is required";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.addservicex.service_cost == "") {
        this.priceError = "Service Price field is required";
        return;
      } else {
        this.priceError = "";
      }

      // Check service price first
      // if (this.addservicex.service_cost < this.addservicex.minimum_price) {
      //   this.priceError = "Service price less than "+this.addservicex.minimum_price+" is not accepted";
      //   return;
      // } else {
      //   this.priceError = "";
      // }

      this.AddService(this.addservicex);
    },

    addDrug(modelId) {
      this.modal_id = modelId;
      if (this.add_drug.insurance_status == "1" && this.pack == "") {
        this.InsError = "This patient can only take drugs on a personal bill";
        return;
      } else {
        this.InsError = "";
      }

      if (this.add_drug.drug_id == "") {
        this.itemError = "Drug field is required";
        return;
      } else {
        this.itemError = "";
      }

      if (this.add_drug.insurance_status == "") {
        this.InsError = "Payment Type field is required";
        return;
      } else {
        this.InsError = "";
      }

      if (this.add_drug.quantity == "" || this.add_drug.quantity < 0.1) {
        this.qtyError = "Quantity field is required";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.add_drug.rec_dosage == "") {
        this.doseError = "Dosage field is required";
        return;
      } else {
        this.doseError = "";
      }

      this.AddDrug(this.add_drug);
    },
    //Now reset the add modal
    resetDrugModal() {
      // alert('Yes Yeah')
      this.add_drug.drug_id = "";
      this.add_drug.quantity = "1";
      this.add_drug.rec_dosage = "";
      this.add_drug.visit_id = "";
      this.add_drug.insurance_company = "";
      this.add_drug.insurance_status = "0";
    },
    editVisit() {
      this.EditVisit(this.editdata);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    // END VIEW SERVICES METHOD
    ClosePatientVisit() {
      this.CloseVisit(this.close_visit.visit_id);
    },

    resetClose() {
      this.close_visit.balance = "";
      this.close_visit.patient_name = "";
      this.close_visit.visit_id = "";
      this.close_visit.index = "";
    },

    // CLOSE VISIT
    close_visit_mode(data, index) {
      // this.close_visit.balance = data.payrecord.amount - data.payrecord.paid;
      this.close_visit.patient_name = data.patient.patientName;
      this.close_visit.visit_id = data.id;
      this.close_visit.index = index;
    },

    fetchprescription() {
      this.itemError = "";
      this.add_drug.rec_dosage = "";
      this.default_dosage = this.DrugAgeRange.filter((obj) => {
        if (
          obj.drug_id == this.add_drug.drug_id &&
          obj.from < this.visit_age &&
          obj.to > this.visit_age &&
          obj.age_unit_no == this.visit_ageunit
        ) {
          return (this.add_drug.rec_dosage = obj.prescription);
        }
      });
    },
  },

  created() {
    this.AssignPatient();
    this.FetchActivePatients();
    // this.FetchInpatient();
    // this.FetchPatients();
    // this.FetchConsultationPatients();
    // this.FetchAntenatalPatients();
    // this.FetchDentalPatients();
    // this.FetchRadiologyPatients();
    // this.FetchProcedurePatients();
    // this.FetchPatientPayments();
    this.FetchPharmacyItems();
    // this.FetchDosage();

    setTimeout(() => {
      this.FetchLabServices();
      this.FetchConsultationServices();
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchAntentalServices();
      this.FetchRadiologyServices();
    }, 2000);
  },
};
</script>
<style scoped>
.loader-line {
  width: 200px;
  height: 3px;
  position: relative;
  overflow: hidden;
  background-color: #ddd;
  margin: 20px auto;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}
.loader-line:before {
  content: "";
  position: absolute;
  left: -50%;
  height: 3px;
  width: 40%;
  background-color: rgb(0, 4, 255);
  -webkit-animation: lineAnim 1s linear infinite;
  -moz-animation: lineAnim 1s linear infinite;
  animation: lineAnim 1s linear infinite;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
}

@keyframes lineAnim {
  0% {
    left: -40%;
  }
  50% {
    left: 20%;
    width: 80%;
  }
  100% {
    left: 100%;
    width: 100%;
  }
}
</style>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
      <PageHeader :title="`${title+' - ('+totalRecords+')'} `" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <lable>Filter Start Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date1"
                  class="form-control"
                />
              </div>
              <div class="col-md-4">
                <lable>Filter End Date</lable>
                <input
                  type="date"
                  v-model="advancedsearch.date2"
                  class="form-control"
                />
              </div>

              <div class="col-md-4">
                <br />
                <button v-if="search_status" disabled class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
                <button v-else @click="SearchPatient()" class="btn btn-primary">
                  FILTER <i class="fa fa-search"></i>
                </button>
              </div>
            </div>

            <div class="row mb-4">
              <div v-if="search_status" class="loader-line"></div>
            </div>

            <div class="row">
            
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->

              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
       
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filterdArray"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }}
                  <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                  <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span class="badge rounded-pill bg-danger" v-else>
                    Not Cleared</span
                  >
                </template>
                <template #cell(gender)="data">
                  {{ data.item.patient.gender == 1 ? "Male" : "Female" }}
                </template>
                <template #cell(ages)="data">
                  {{ data.item.patient.lastvisit.age }}
                  <span v-if="data.item.patient.lastvisit.age_unit == 1"
                    >Years</span
                  >
                  <span v-else-if="data.item.patient.lastvisit.age_unit == 2"
                    >Months</span
                  >
                  <span v-else-if="data.item.patient.lastvisit.age_unit == 3"
                    >Days</span
                  >
                  <span v-else>--</span>
                </template>
                <template #cell(services)="data">
                  <button
                    v-if="user_permissions.view_services"
                    v-b-modal.modal-lg
                    class="btn btn-info btn-sm"
                    @click="View_Services(data)"
                  >
                    <i class="fa fa-eye"></i> View
                  </button>
                  <button
                    v-else
                    v-b-modal.modal-lg
                    class="btn btn-outline-info btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> View
                  </button>
                </template>
                <template #cell(actions)="data">
                  <span v-if="user_permissions.visit_profile">
                    <router-link
                      :to="{
                        name: 'VisitProfile',
                        params: { visit: data.item.id },
                      }"
                      class="btn btn-primary btn-sm"
                    >
                      <i class="fa fa-eye"></i> Profile
                    </router-link>
                  </span>
                  <span v-else>
                    <button
                      class="btn btn-outline-primary btn-sm"
                      title="You are restricted"
                    >
                      <i class="fa fa-ban"></i> Profile
                    </button>
                  </span>
                  <button
                    v-if="user_permissions.edit_visit"
                    v-b-modal.edit-visit-modal
                    class="btn btn-success btn-sm m-1"
                    @click="showEditModal(data)"
                  >
                    <i class="fa fa-edit"></i> Edit
                  </button>
                  <button
                    v-else
                    class="btn btn-outline-success btn-sm m-1"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i> Edit
                  </button>

                  <button
                    v-if="user_permissions.delete_visit"
                    class="btn btn-danger btn-sm"
                    @click="yes(data)"
                  >
                    <i class="fa fa-trash-alt"></i> Delete
                  </button>
                  <button
                    v-else
                    class="btn btn-outline-danger btn-sm"
                    title="You are restricted"
                  >
                    <i class="fa fa-ban"></i>
                    Delete
                  </button>
                  <!--Visit closing-->
                  <button
                    v-if="
                      user_permissions
                        ? user_permissions.view_close_visit
                        : false
                    "
                    v-b-modal.modal-close_visit
                    class="btn btn-danger btn-sm m-1"
                    @click="close_visit_mode(data.item, data.index)"
                  >
                    <span><strong>X</strong></span> Close
                  </button>
                  <button v-else class="btn btn-outline-danger btn-sm m-1">
                    <i class="fas fa-ban"></i> Close
                  </button>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!active_patients" class="text-primary">
                  <b-spinner
                    class="m-0"
                    variant="primary"
                    role="status"
                  ></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- VIEW SERVICES model -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="modal-lg"
                    size="lg"
                    :title="
                      'SERVICES FOR ' + patient_services.name.toUpperCase()
                    "
                    title-class="font-18"
                    hide-footer
                  >
                    <div class="row">
                      <div class="col-8"></div>
                      <div class="col-2">
                        <button
                          v-if="
                            user_permissions
                              ? user_permissions.order_service
                              : false
                          "
                          v-b-modal.add-drug-modal
                          class="btn btn-primary btn-sm float-end"
                        >
                          <i class="fa fa-plus"></i> Add Drug
                        </button>
                        <button
                          v-else
                          title="You are restricted"
                          class="btn btn-outline-primary btn-sm float-end"
                        >
                          <i class="fa fa-ban"></i> Add Drug
                        </button>
                      </div>
                      <div class="col-2">
                        <button
                          v-if="
                            user_permissions
                              ? user_permissions.order_service
                              : false
                          "
                          v-b-modal.add-service-modal
                          class="btn btn-primary btn-sm float-end"
                        >
                          <i class="fa fa-plus"></i> Add Service
                        </button>
                        <button
                          v-else
                          title="You are restricted"
                          class="btn btn-outline-primary btn-sm float-end"
                        >
                          <i class="fa fa-ban"></i> Add Service
                        </button>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-bordered border-primary mb-0">
                        <thead>
                          <tr>
                            <th>SERVICE</th>
                            <th>AMOUNT</th>
                            <th>STATUS</th>
                            <th>TIME</th>
                            <th>Pay Type</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(serv, index) in patient_services.services"
                            :key="index"
                          >
                            <td>
                              {{ serv.service.name ? serv.service.name : "--" }}
                            </td>
                            <td>
                              {{ serv.servicePrice ? serv.servicePrice : "--" }}
                            </td>
                            <td>
                              {{ serv.serviceStatus ? "Done" : "Pending..." }}
                            </td>
                            <td>
                              {{ serv.dateCreated ? serv.dateCreated : "--" }}
                            </td>
                            <td>
                              {{
                                serv.insured == "1" ? "Insurance" : "Personal"
                              }}
                            </td>
                            <td>
                              <button
                                v-b-modal.delete-service-modal
                                class="btn btn-danger btn-sm"
                                @click="
                                  showDeleteModal(serv.id, serv.service.type)
                                "
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(
                              serv, index
                            ) in patient_services.completetests"
                            :key="index"
                          >
                            <td>
                              {{ serv.test.name ? serv.test.name : "--" }}
                            </td>
                            <td>{{ serv.cost ? serv.cost : "--" }}</td>
                            <td>Done</td>
                            <td>
                              {{ serv.dateCreated ? serv.dateCreated : "--" }}
                            </td>
                            <td>
                              {{
                                serv.insured == "1" ? "Insurance" : "Personal"
                              }}
                            </td>
                            <td>
                              <button disabled class="btn btn-warning btn-sm">
                                Done
                              </button>
                            </td>
                          </tr>
                        </tbody>
                        <tbody>
                          <tr
                            v-for="(
                              serv, index
                            ) in patient_services.labrequests"
                            :key="index"
                          >
                            <td>{{ serv.test.name ? serv.test.name : "" }}</td>
                            <td>{{ serv.amount ? serv.amount : "--" }}</td>
                            <td>Pending...</td>
                            <td>
                              {{ serv.dateCreated ? serv.dateCreated : "--" }}
                            </td>
                            <td>
                              {{
                                serv.insured == "1" ? "Insurance" : "Personal"
                              }}
                            </td>
                            <td>
                              <button
                                v-b-modal.delete-service-modal
                                class="btn btn-danger btn-sm"
                                @click="showDeleteModal(serv.id, 4)"
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-modal>
                  <!-- CLOSE VISIT MODEL -->
                  <b-modal
                    id="modal-close_visit"
                    hide-footer
                    @hidden="resetClose"
                  >
                    <template #modal-title
                      ><p class="text-uppercase">
                        Close {{ close_visit.patient_name }}'s Visit
                      </p></template
                    >
                    <h3
                      v-if="close_visit.balance > 0"
                      class="text-danger text-center"
                    >
                      Are you sure to close
                      <b>{{ this.close_visit.patient_name }}</b
                      >'s visit with a balance of
                      <code>{{ this.close_visit.balance }}</code>
                    </h3>
                    <h3 v-else class="text-danger text-center">
                      Are you sure you want to close
                      <b>{{ this.close_visit.patient_name }}</b
                      >'s visit
                    </h3>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary float-start"
                        @click="closeModal('modal-close_visit')"
                      >
                        cancel
                      </button>
                      <button
                        type="submit"
                        @click="ClosePatientVisit()"
                        class="btn btn-success"
                      >
                        close visit
                      </button>
                    </div>
                  </b-modal>

                  <!-- edit modal starts -->
                  <b-modal id="edit-visit-modal" size="lg" hide-footer>
                    <template #modal-title>
                      Edit Visit Details for {{ editdata.new_name }}
                    </template>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Temperature</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter temperature"
                              type="number"
                              class="form-control"
                              v-model="editdata.temperature"
                              step="any"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Weight</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter Weight"
                              type="text"
                              class="form-control"
                              v-model="editdata.weight"
                              step="any"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Height</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter Height"
                              type="text"
                              class="form-control"
                              v-model="editdata.height"
                              step="any"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Pulse</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter pulse"
                              type="number"
                              class="form-control"
                              v-model="editdata.pulse"
                              step="any"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>MUAC(cm)</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter MUAC"
                              type="number"
                              class="form-control"
                              step="any"
                              v-model="editdata.mauc"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Blood Pressure</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter blood pressure"
                              type="text"
                              class="form-control"
                              step="any"
                              v-model="editdata.pressure"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Age</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter age"
                              type="number"
                              class="form-control"
                              v-model="editdata.age"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Next of Kin</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter next of kin"
                              type="text"
                              class="form-control"
                              v-model="editdata.nextofkin"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Age Unit</label>
                          <div class="input-group">
                            <select
                              class="form-control"
                              v-model="editdata.age_unit"
                            >
                              <option value="1">Years</option>
                              <option value="2">Months</option>
                              <option value="3">Days</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Next of Kin Contact</label>
                          <div class="input-group">
                            <input
                              placeholder="Enter next of kin contact"
                              type="number"
                              class="form-control"
                              v-model="editdata.nextofkincontact"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group mb-3">
                          <label>Visit Date</label>
                          <div class="input-group">
                            <input
                              type="date"
                              class="form-control"
                              v-model="editdata.visitdate"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="closeModal('edit-visit-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="editVisit()"
                      >
                        Save Changes
                        <b-spinner
                          v-if="saving_status"
                          style="float: right"
                          small
                          variant="light"
                          role="status"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->

                  <!-- delete service modal starts -->
                  <b-modal
                    id="add-service-modal"
                    @hidden="resetAdd"
                    hide-footer
                  >
                    <template #modal-title>
                      Add service to {{ patient_services.name }}
                    </template>
                    <div class="row">
                      <div class="form-group">
                        <label class="col-form-label">Payment Type</label>
                        <select
                          class="form-control"
                          v-model="addservicex.insurance_status"
                          @change="checkStaus()"
                        >
                          <option
                            v-for="(ty, index) in PaymentType"
                            :key="index"
                            :value="ty.id"
                          >
                            {{ ty.name }}
                          </option>
                        </select>
                        <div class="text-danger" v-if="InsError">
                          <em>{{ InsError }}</em>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">Service Category </label>
                        <model-list-select
                          :list="department_add ? department_add : []"
                          v-model="addservicex.department"
                          option-value="id"
                          option-text="name"
                          placeholder="Select Category"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="deptError">
                          <em>{{ deptError }}</em>
                        </div>
                      </div>
                      <div
                        class="form-group"
                        v-if="addservicex.insurance_status == '1'"
                      >
                        <label class="col-form-label">Service</label>
                        <model-list-select
                          :list="filterSevicesx ? filterSevicesx : []"
                          v-model="addservicex.service"
                          @input="getCost()"
                          option-value="serviceId"
                          option-text="serviceName"
                          placeholder="select Service"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="serviceError">
                          <em>{{ serviceError }}</em>
                        </div>
                      </div>
                      <div class="form-group" v-else>
                        <label class="col-form-label">Service</label>

                        <model-list-select
                          :list="filterSevices ? filterSevices : []"
                          v-model="addservicex.service"
                          @input="getPrice()"
                          option-value="id"
                          option-text="serviceName"
                          placeholder="select Service"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="serviceError">
                          <em>{{ serviceError }}</em>
                        </div>
                      </div>
                      <div lass="form-group">
                        <label class="col-form-label" for="quantity"
                          >Quantity</label
                        >
                        <input
                          v-model="addservicex.quantity"
                          id="quantity"
                          type="number"
                          name="quantity"
                          class="form-control"
                          placeholder="Quantity"
                        />
                        <div class="text-danger" v-if="qtyError">
                          <em>{{ qtyError }}</em>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="service_price">Service Price</label>
                        <input
                          v-model="addservicex.service_cost"
                          id="service_price"
                          type="text"
                          name="service_price"
                          class="form-control"
                          placeholder="Service price"
                        />
                        <div class="text-danger" v-if="priceError">
                          <em>{{ priceError }}</em>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="closeModal('add-service-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addService('add-service-modal')"
                      >
                        <i class="fa fa-check"></i> Submit
                        <b-spinner
                          v-if="OrderServiceStatus"
                          style="float: right"
                          small
                          variant="light"
                          role="status"
                          t
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->

                  <!-- add drug modal starts -->
                  <b-modal
                    id="add-drug-modal"
                    ref="modal"
                    @hidden="resetDrugModal"
                    hide-footer
                  >
                    <template #modal-title>
                      Add drug to {{ patient_services.name }}
                    </template>
                    <div class="row">
                      <div class="form-group">
                        <label class="col-form-label">Payment Type</label>
                        <select
                          class="form-control"
                          v-model="add_drug.insurance_status"
                          @change="checkInsuranceStaus()"
                        >
                          <option
                            v-for="(ty, index) in PaymentType"
                            :key="index"
                            :value="ty.id"
                          >
                            {{ ty.name }}
                          </option>
                        </select>
                        <div class="text-danger" v-if="InsError">
                          <em>{{ InsError }}</em>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">Drug</label>
                          <model-list-select
                          v-if="add_drug.insurance_status == 1"
                          :list="filterDrugx?filterDrugx:[]"
                          v-model="add_drug.drug_id"
                          option-value="serviceId"
                          option-text="serviceName"
                          placeholder="Select Drug"
                          @input="set_price()"
                        >
                        </model-list-select>
                     
                        <model-list-select
                          v-else
                          :list="PharmacyItems?PharmacyItems:[]"
                          v-model="add_drug.drug_id"
                          option-value="id"
                          option-text="serviceName"
                          placeholder="Select Drug"
                        >
                        </model-list-select>
                        <div class="text-danger" v-if="itemError">
                          <em>{{ itemError }}</em>
                        </div>
                         
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="drug_quantity"
                          >Quantity</label
                        >
                        <input
                          v-model="add_drug.quantity"
                          id="drug_quantity"
                          type="number"
                          name="drug_quantity"
                          class="form-control"
                          placeholder="Drug Quantity"
                        />
                        <div class="text-danger" v-if="qtyError">
                          <em>{{ qtyError }}</em>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="dosage"
                          >Dosage</label
                        >
                        <input
                          v-model="add_drug.rec_dosage"
                          id="dosage"
                          type="text"
                          name="dosage"
                          class="form-control"
                          placeholder="Enter dosage e.g Tabs PCM 1g TDs x 3/7"
                        />
                        <div class="text-danger" v-if="doseError">
                          <em>{{ doseError }}</em>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="closeModal('add-drug-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addDrug('add-drug-modal')"
                      >
                        <i class="fa fa-check"></i> Submit
                        <b-spinner
                          v-if="OrderServiceStatus"
                          style="float: right"
                          small
                          variant="light"
                          role="status"
                          t
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->

                  <!-- VIEW SERVICES model-->
                  <!-- delete service modal starts -->
                  <b-modal id="delete-service-modal" size="md" hide-footer>
                    <template #modal-title>
                      Delete this service from {{ patient_services.name }}
                    </template>
                    <div class="row">
                      <div class="form-group mb-3">
                        <label>Reason</label>
                        <div class="input-group">
                          <input
                            placeholder="Enter Reason for deleting"
                            type="text"
                            class="form-control"
                            v-model="deletedata.reason"
                          />
                        </div>
                        <span v-if="reasonError" class="text-danger">{{
                          reasonError
                        }}</span>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="closeModal('delete-service-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="RemoveService('delete-service-modal')"
                      >
                        Proceed
                        <b-spinner
                          v-if="saving_status && !reasonError"
                          style="float: right"
                          small
                          variant="light"
                          role="status"
                          t
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <!-- END VIEW SERVICES model-->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>